interface DialogSettings {
  top?: number
  isOpen?: boolean
  type?: 'dialog' | 'modal' | 'fullscreen' | 'from-left' | 'from-right' | 'from-top' | 'from-bottom' | 'responsive'
  [key: string]: unknown
}

export function useUiDialog(name: string, settings?: DialogSettings) {
  const dialog = useState<HTMLDialogElement | undefined>(`uiDialog__${name}`, () => undefined)
  const dialogSettings = useState<DialogSettings>(`uiDialogSettings__${name}`, () => ({
    top: 0,
    isOpen: false,
    type: 'dialog',
  }))

  if (settings) {
    dialogSettings.value = { ...dialogSettings.value, ...settings }
  }

  // Actuation (show/showModal/close) happens inside Ui/Dialog.vue, which watches
  // `isOpen` and drives its own local element. Keeping the imperative calls out
  // of here avoids acting on a stale/detached element after SPA navigation
  // (the shared `dialog` ref can point at an unmounting instance).
  const open = () => {
    dialogSettings.value = {
      ...dialogSettings.value,
      top: window.scrollY,
      isOpen: true,
    }
  }

  const close = () => {
    dialogSettings.value = {
      ...dialogSettings.value,
      isOpen: false,
    }
  }

  const route = useRoute()
  watch(() => route.fullPath, (newFullPath, oldFullPath) => {
    if (newFullPath?.split('#').at(0) !== oldFullPath?.split('#').at(0)) {
      close()
    }
  })

  return {
    dialog,
    settings: dialogSettings,
    open,
    close,
  }
}
